import axios from '~/axiosWrapper';
import { API } from '~/app/routes';
import { Archive, ArchivePayload, Equipment, MachineSpecification } from '~/types';
import { assertOnlineForRemote } from './remoteGuard';

export class DocumentationRemoteDataSource {
  fetchSpecifications(id: MachineSpecification['id']): Promise<MachineSpecification> {
    assertOnlineForRemote();
    return axios.get(`${API.machines}/specifications/${id}`);
  }

  fetchEquipments(equipmentId: Equipment['id']): Promise<Equipment[]> {
    assertOnlineForRemote();
    return axios.get(`${API.machines}/equipments/${equipmentId}`);
  }

  fetchFavoriteSpecifications(): Promise<MachineSpecification[]> {
    assertOnlineForRemote();
    return axios.get(`${API.machines}/specifications/favorite`);
  }

  fetchArchives(payload: ArchivePayload): Promise<Archive[]> {
    assertOnlineForRemote();
    return axios.get(`${API.machines}/archives/${payload.machineId}/${payload.parentFolderId}`);
  }
}

export const documentationRemote = new DocumentationRemoteDataSource();
